import { put, call } from 'redux-saga/effects';
import { clientCategoryList, clientCategoryAdd, clientCategoryEdit, clientCategoryUpdate, clientCategoryDelete } from '../../../services/settings/affiliates/clientCategoryService';

import * as types from '../../../actions';

export function* clientCategoryListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(clientCategoryList, payload);
      yield put({ type: types.CLIENT_CATEGORY_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.CLIENT_CATEGORY_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
  }

export function* clientCategoryAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(clientCategoryAdd, payload);
      yield put({ type: types.CLIENT_CATEGORY_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.CLIENT_CATEGORY_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCategoryEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCategoryEdit, payload);
    yield put({ type: types.CLIENT_CATEGORY_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CATEGORY_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCategoryUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCategoryUpdate, payload);
    yield put({ type: types.CLIENT_CATEGORY_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CATEGORY_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCategoryDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCategoryDelete, payload);
    yield put({ type: types.CLIENT_CATEGORY_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CATEGORY_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}